import {Component, Input, OnInit, OnChanges} from '@angular/core';
import {MaterialModule} from '@app/material.module';
import {TablerIconsModule} from 'angular-tabler-icons';
import {TranslateModule} from '@ngx-translate/core';
import {Room} from '@interfaces/room';

export type RoomStatus = 'busy' | 'waiting' | 'empty';

/** Same rules the "Entra" button follows: two people = call in progress, one = technician waiting. */
export function getRoomStatus(room: Room | null | undefined): RoomStatus {
  if (room?.connected && (room.connectionNumber && room.connectionNumber > 1)) {
    return 'busy';
  }
  if (room?.connected && room.connectionNumber === 1) {
    return 'waiting';
  }
  return 'empty';
}

@Component({
  selector: 'app-item-room',
  imports: [TablerIconsModule, MaterialModule, TranslateModule],
  standalone: true,
  templateUrl: './item-room.component.html',
  styleUrl: './item-room.component.scss'
})
export class ItemRoomComponent implements OnInit, OnChanges {
  defaultRoom: Room = {
    id: 0,
    name: '',
    uuid: '',
    enabled: false,
    connected: false,
    connectionNumber: 0
  };

  @Input() room!: Room;
  status: RoomStatus = 'empty';
  // TODO: di default farla partire disabilitata
  disabledBTN = false;
  // disabledBTN = true;
  // Translation key used for the tooltip that explains why "Entra" is disabled
  tooltipKey = "";

  ngOnInit() {
    this.updateState();
  }

  ngOnChanges() {
    this.updateState();
  }

  get initials(): string {
    const technician = this.room?.technician;
    const first = (technician?.name || '').trim().charAt(0);
    const last = (technician?.lastname || '').trim().charAt(0);
    return (last + first).toUpperCase() || '?';
  }

  private updateState() {
    const room = this.room ?? this.defaultRoom;
    this.status = getRoomStatus(room);

    if (this.status === 'busy') {
      // A technician and an operator are already in the call: cannot join
      this.disabledBTN = true;
      this.tooltipKey = "rooms.cannot_connect_room_busy";
    } else if (this.status === 'waiting') {
      // A technician is waiting: connection allowed
      this.disabledBTN = false;
      this.tooltipKey = "";
    } else {
      // Technician not listed: a headset still in the room after a panel reload is listed again only
      // when it offers, so entering stays allowed and the panel offers the call itself once inside
      this.disabledBTN = false;
      this.tooltipKey = "";
    }
  }

  openRoom() {
    window.location.href = '/support/room/' + this.room.uuid;
  }

}
